module.exports = __webpack_public_path__ + "img/stock-in-out.479b3fe3.svg";